module.exports = __webpack_public_path__ + "static/sportovni-odpoledne-na-czu-01-9a4162593b4499218ba1831b9405585e.jpg";